// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__t0nqL","tabList":"styles_tabList__iJ+FO","tabButton":"styles_tabButton__RI7d8","tabButtonActive":"styles_tabButtonActive__eWxtF","count":"styles_count__kmY9R"};